module.exports = __webpack_public_path__ + "static/media/shipping-truck-alt.61e2ddb8.svg";